import axios from "axios";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { url } from "../link";
const Updateregistrationremark = () => {
  var rx = 0;
  const { state } = useLocation();
  const [rrid, setrrid] = useState(state[rx++]);
  const [remark, setremark] = useState(state[rx++]);
  const [remarkdate, setremarkdate] = useState(state[rx++]);
  const [rid, setrid] = useState(state[rx++]);
  const nav = useNavigate();
  const submitdata = () => {
    const value = {
      rrid: rrid,
      remark: remark,
      remarkdate: remarkdate,
      rid: rid,
    };
    axios
      .post(url + "/edusphere/updateregistrationremark", value)
      .then((response) => {
        nav("/viewregistrationremark");
      });
  };
  return (
    <div>
      <h1>Add registrationremark</h1>
      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setrrid(e.target.value)}
          value={rrid}
          placeholder="Enter rrid"
        />
        <label htmlFor="rrid">rrid</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setremark(e.target.value)}
          value={remark}
          placeholder="Enter remark"
        />
        <label htmlFor="remark">remark</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setremarkdate(e.target.value)}
          value={remarkdate}
          placeholder="Enter remarkdate"
        />
        <label htmlFor="remarkdate">remarkdate</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setrid(e.target.value)}
          value={rid}
          placeholder="Enter rid"
        />
        <label htmlFor="rid">rid</label>
      </div>

      <input
        type="submit"
        className="btn btn-primary"
        onClick={submitdata}
        style={{ width: "100%" }}
      />
    </div>
  );
};
export default Updateregistrationremark;
